export const SET_PROJECT_IS_OPEN = 'SET_PROJECT_IS_OPEN';



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectAddress/constants.js